// UI dictionaries (ratified 2026-07-12): resolved client-side — the chosen
// language lives in localStorage ('tvirt-lang'), no URL prefix.
//
// I18N GOVERNANCE (task #171, ratified 2026-08-03): ITALIAN is the SOURCE
// language — every other locale (English included) is a translation of the
// Italian strings, and anglicisms kept by the source are TRANSLITERATED, never
// translated (es 'clúster', never 'grupo'). Every non-Italian locale carries a
// sidecar meta/<section>.<locale>.meta.json mapping key → sha256 (12 hex) of
// the Italian string the translation derives from; the tests recompute the
// hash of the CURRENT Italian and flag stale/untranslated keys per language.
// Runtime dictionaries stay plain strings — sidecars are read only by tests
// and by scripts/i18n-status.mjs (zero bundle cost).

// @generated-index by scripts/split-dictionaries.mjs (task #127): this file only
// recomposes ./sections/* into the same external shape as the old monolith —
// the per-area section files are the source of truth, edit THERE. To reconcile
// a merge that lands new keys in a monolithic dictionaries.ts, re-run:
//   node scripts/split-dictionaries.mjs

import { mergeDelta, VARIANT_BASE } from './delta'

import * as common from './sections/common'
import * as auth from './sections/auth'
import * as cluster from './sections/cluster'
import * as system from './sections/system'
import * as tasks from './sections/tasks'
import * as apps from './sections/apps'
import * as backups from './sections/backups'
import * as networks from './sections/networks'
import * as storage from './sections/storage'
import * as hci from './sections/hci'
import * as vms from './sections/vms'

import * as commonEsES from './sections/common.es-ES'
import * as authEsES from './sections/auth.es-ES'
import * as clusterEsES from './sections/cluster.es-ES'
import * as systemEsES from './sections/system.es-ES'
import * as tasksEsES from './sections/tasks.es-ES'
import * as appsEsES from './sections/apps.es-ES'
import * as backupsEsES from './sections/backups.es-ES'
import * as networksEsES from './sections/networks.es-ES'
import * as storageEsES from './sections/storage.es-ES'
import * as hciEsES from './sections/hci.es-ES'
import * as vmsEsES from './sections/vms.es-ES'

import * as commonPtPT from './sections/common.pt-PT'
import * as authPtPT from './sections/auth.pt-PT'
import * as clusterPtPT from './sections/cluster.pt-PT'
import * as systemPtPT from './sections/system.pt-PT'
import * as tasksPtPT from './sections/tasks.pt-PT'
import * as appsPtPT from './sections/apps.pt-PT'
import * as backupsPtPT from './sections/backups.pt-PT'
import * as networksPtPT from './sections/networks.pt-PT'
import * as storagePtPT from './sections/storage.pt-PT'
import * as hciPtPT from './sections/hci.pt-PT'
import * as vmsPtPT from './sections/vms.pt-PT'

import * as commonFrFR from './sections/common.fr-FR'
import * as authFrFR from './sections/auth.fr-FR'
import * as clusterFrFR from './sections/cluster.fr-FR'
import * as systemFrFR from './sections/system.fr-FR'
import * as tasksFrFR from './sections/tasks.fr-FR'
import * as appsFrFR from './sections/apps.fr-FR'
import * as backupsFrFR from './sections/backups.fr-FR'
import * as networksFrFR from './sections/networks.fr-FR'
import * as storageFrFR from './sections/storage.fr-FR'
import * as hciFrFR from './sections/hci.fr-FR'
import * as vmsFrFR from './sections/vms.fr-FR'

import * as commonDeDE from './sections/common.de-DE'
import * as authDeDE from './sections/auth.de-DE'
import * as clusterDeDE from './sections/cluster.de-DE'
import * as systemDeDE from './sections/system.de-DE'
import * as tasksDeDE from './sections/tasks.de-DE'
import * as appsDeDE from './sections/apps.de-DE'
import * as backupsDeDE from './sections/backups.de-DE'
import * as networksDeDE from './sections/networks.de-DE'
import * as storageDeDE from './sections/storage.de-DE'
import * as hciDeDE from './sections/hci.de-DE'
import * as vmsDeDE from './sections/vms.de-DE'

import * as commonDaDK from './sections/common.da-DK'
import * as authDaDK from './sections/auth.da-DK'
import * as clusterDaDK from './sections/cluster.da-DK'
import * as systemDaDK from './sections/system.da-DK'
import * as tasksDaDK from './sections/tasks.da-DK'
import * as appsDaDK from './sections/apps.da-DK'
import * as backupsDaDK from './sections/backups.da-DK'
import * as networksDaDK from './sections/networks.da-DK'
import * as storageDaDK from './sections/storage.da-DK'
import * as hciDaDK from './sections/hci.da-DK'
import * as vmsDaDK from './sections/vms.da-DK'

import * as commonFiFI from './sections/common.fi-FI'
import * as authFiFI from './sections/auth.fi-FI'
import * as clusterFiFI from './sections/cluster.fi-FI'
import * as systemFiFI from './sections/system.fi-FI'
import * as tasksFiFI from './sections/tasks.fi-FI'
import * as appsFiFI from './sections/apps.fi-FI'
import * as backupsFiFI from './sections/backups.fi-FI'
import * as networksFiFI from './sections/networks.fi-FI'
import * as storageFiFI from './sections/storage.fi-FI'
import * as hciFiFI from './sections/hci.fi-FI'
import * as vmsFiFI from './sections/vms.fi-FI'

import * as commonNoNO from './sections/common.no-NO'
import * as authNoNO from './sections/auth.no-NO'
import * as clusterNoNO from './sections/cluster.no-NO'
import * as systemNoNO from './sections/system.no-NO'
import * as tasksNoNO from './sections/tasks.no-NO'
import * as appsNoNO from './sections/apps.no-NO'
import * as backupsNoNO from './sections/backups.no-NO'
import * as networksNoNO from './sections/networks.no-NO'
import * as storageNoNO from './sections/storage.no-NO'
import * as hciNoNO from './sections/hci.no-NO'
import * as vmsNoNO from './sections/vms.no-NO'

import * as commonSvSE from './sections/common.sv-SE'
import * as authSvSE from './sections/auth.sv-SE'
import * as clusterSvSE from './sections/cluster.sv-SE'
import * as systemSvSE from './sections/system.sv-SE'
import * as tasksSvSE from './sections/tasks.sv-SE'
import * as appsSvSE from './sections/apps.sv-SE'
import * as backupsSvSE from './sections/backups.sv-SE'
import * as networksSvSE from './sections/networks.sv-SE'
import * as storageSvSE from './sections/storage.sv-SE'
import * as hciSvSE from './sections/hci.sv-SE'
import * as vmsSvSE from './sections/vms.sv-SE'

import * as commonNlNL from './sections/common.nl-NL'
import * as authNlNL from './sections/auth.nl-NL'
import * as clusterNlNL from './sections/cluster.nl-NL'
import * as systemNlNL from './sections/system.nl-NL'
import * as tasksNlNL from './sections/tasks.nl-NL'
import * as appsNlNL from './sections/apps.nl-NL'
import * as backupsNlNL from './sections/backups.nl-NL'
import * as networksNlNL from './sections/networks.nl-NL'
import * as storageNlNL from './sections/storage.nl-NL'
import * as hciNlNL from './sections/hci.nl-NL'
import * as vmsNlNL from './sections/vms.nl-NL'

import * as commonPlPL from './sections/common.pl-PL'
import * as authPlPL from './sections/auth.pl-PL'
import * as clusterPlPL from './sections/cluster.pl-PL'
import * as systemPlPL from './sections/system.pl-PL'
import * as tasksPlPL from './sections/tasks.pl-PL'
import * as appsPlPL from './sections/apps.pl-PL'
import * as backupsPlPL from './sections/backups.pl-PL'
import * as networksPlPL from './sections/networks.pl-PL'
import * as storagePlPL from './sections/storage.pl-PL'
import * as hciPlPL from './sections/hci.pl-PL'
import * as vmsPlPL from './sections/vms.pl-PL'

import * as commonLvLV from './sections/common.lv-LV'
import * as authLvLV from './sections/auth.lv-LV'
import * as clusterLvLV from './sections/cluster.lv-LV'
import * as systemLvLV from './sections/system.lv-LV'
import * as tasksLvLV from './sections/tasks.lv-LV'
import * as appsLvLV from './sections/apps.lv-LV'
import * as backupsLvLV from './sections/backups.lv-LV'
import * as networksLvLV from './sections/networks.lv-LV'
import * as storageLvLV from './sections/storage.lv-LV'
import * as hciLvLV from './sections/hci.lv-LV'
import * as vmsLvLV from './sections/vms.lv-LV'

import * as commonLtLT from './sections/common.lt-LT'
import * as authLtLT from './sections/auth.lt-LT'
import * as clusterLtLT from './sections/cluster.lt-LT'
import * as systemLtLT from './sections/system.lt-LT'
import * as tasksLtLT from './sections/tasks.lt-LT'
import * as appsLtLT from './sections/apps.lt-LT'
import * as backupsLtLT from './sections/backups.lt-LT'
import * as networksLtLT from './sections/networks.lt-LT'
import * as storageLtLT from './sections/storage.lt-LT'
import * as hciLtLT from './sections/hci.lt-LT'
import * as vmsLtLT from './sections/vms.lt-LT'

import * as commonEtEE from './sections/common.et-EE'
import * as authEtEE from './sections/auth.et-EE'
import * as clusterEtEE from './sections/cluster.et-EE'
import * as systemEtEE from './sections/system.et-EE'
import * as tasksEtEE from './sections/tasks.et-EE'
import * as appsEtEE from './sections/apps.et-EE'
import * as backupsEtEE from './sections/backups.et-EE'
import * as networksEtEE from './sections/networks.et-EE'
import * as storageEtEE from './sections/storage.et-EE'
import * as hciEtEE from './sections/hci.et-EE'
import * as vmsEtEE from './sections/vms.et-EE'

import * as commonHyAM from './sections/common.hy-AM'
import * as authHyAM from './sections/auth.hy-AM'
import * as clusterHyAM from './sections/cluster.hy-AM'
import * as systemHyAM from './sections/system.hy-AM'
import * as tasksHyAM from './sections/tasks.hy-AM'
import * as appsHyAM from './sections/apps.hy-AM'
import * as backupsHyAM from './sections/backups.hy-AM'
import * as networksHyAM from './sections/networks.hy-AM'
import * as storageHyAM from './sections/storage.hy-AM'
import * as hciHyAM from './sections/hci.hy-AM'
import * as vmsHyAM from './sections/vms.hy-AM'

import * as commonSqAL from './sections/common.sq-AL'
import * as authSqAL from './sections/auth.sq-AL'
import * as clusterSqAL from './sections/cluster.sq-AL'
import * as systemSqAL from './sections/system.sq-AL'
import * as tasksSqAL from './sections/tasks.sq-AL'
import * as appsSqAL from './sections/apps.sq-AL'
import * as backupsSqAL from './sections/backups.sq-AL'
import * as networksSqAL from './sections/networks.sq-AL'
import * as storageSqAL from './sections/storage.sq-AL'
import * as hciSqAL from './sections/hci.sq-AL'
import * as vmsSqAL from './sections/vms.sq-AL'

import * as commonSrLatnRS from './sections/common.sr-Latn-RS'
import * as authSrLatnRS from './sections/auth.sr-Latn-RS'
import * as clusterSrLatnRS from './sections/cluster.sr-Latn-RS'
import * as systemSrLatnRS from './sections/system.sr-Latn-RS'
import * as tasksSrLatnRS from './sections/tasks.sr-Latn-RS'
import * as appsSrLatnRS from './sections/apps.sr-Latn-RS'
import * as backupsSrLatnRS from './sections/backups.sr-Latn-RS'
import * as networksSrLatnRS from './sections/networks.sr-Latn-RS'
import * as storageSrLatnRS from './sections/storage.sr-Latn-RS'
import * as hciSrLatnRS from './sections/hci.sr-Latn-RS'
import * as vmsSrLatnRS from './sections/vms.sr-Latn-RS'

import * as commonSrCyrlRS from './sections/common.sr-Cyrl-RS'
import * as authSrCyrlRS from './sections/auth.sr-Cyrl-RS'
import * as clusterSrCyrlRS from './sections/cluster.sr-Cyrl-RS'
import * as systemSrCyrlRS from './sections/system.sr-Cyrl-RS'
import * as tasksSrCyrlRS from './sections/tasks.sr-Cyrl-RS'
import * as appsSrCyrlRS from './sections/apps.sr-Cyrl-RS'
import * as backupsSrCyrlRS from './sections/backups.sr-Cyrl-RS'
import * as networksSrCyrlRS from './sections/networks.sr-Cyrl-RS'
import * as storageSrCyrlRS from './sections/storage.sr-Cyrl-RS'
import * as hciSrCyrlRS from './sections/hci.sr-Cyrl-RS'
import * as vmsSrCyrlRS from './sections/vms.sr-Cyrl-RS'

import * as commonBgBG from './sections/common.bg-BG'
import * as authBgBG from './sections/auth.bg-BG'
import * as clusterBgBG from './sections/cluster.bg-BG'
import * as systemBgBG from './sections/system.bg-BG'
import * as tasksBgBG from './sections/tasks.bg-BG'
import * as appsBgBG from './sections/apps.bg-BG'
import * as backupsBgBG from './sections/backups.bg-BG'
import * as networksBgBG from './sections/networks.bg-BG'
import * as storageBgBG from './sections/storage.bg-BG'
import * as hciBgBG from './sections/hci.bg-BG'
import * as vmsBgBG from './sections/vms.bg-BG'

import * as commonTrTR from './sections/common.tr-TR'
import * as authTrTR from './sections/auth.tr-TR'
import * as clusterTrTR from './sections/cluster.tr-TR'
import * as systemTrTR from './sections/system.tr-TR'
import * as tasksTrTR from './sections/tasks.tr-TR'
import * as appsTrTR from './sections/apps.tr-TR'
import * as backupsTrTR from './sections/backups.tr-TR'
import * as networksTrTR from './sections/networks.tr-TR'
import * as storageTrTR from './sections/storage.tr-TR'
import * as hciTrTR from './sections/hci.tr-TR'
import * as vmsTrTR from './sections/vms.tr-TR'

import * as commonElGR from './sections/common.el-GR'
import * as authElGR from './sections/auth.el-GR'
import * as clusterElGR from './sections/cluster.el-GR'
import * as systemElGR from './sections/system.el-GR'
import * as tasksElGR from './sections/tasks.el-GR'
import * as appsElGR from './sections/apps.el-GR'
import * as backupsElGR from './sections/backups.el-GR'
import * as networksElGR from './sections/networks.el-GR'
import * as storageElGR from './sections/storage.el-GR'
import * as hciElGR from './sections/hci.el-GR'
import * as vmsElGR from './sections/vms.el-GR'

import * as commonHuHU from './sections/common.hu-HU'
import * as authHuHU from './sections/auth.hu-HU'
import * as clusterHuHU from './sections/cluster.hu-HU'
import * as systemHuHU from './sections/system.hu-HU'
import * as tasksHuHU from './sections/tasks.hu-HU'
import * as appsHuHU from './sections/apps.hu-HU'
import * as backupsHuHU from './sections/backups.hu-HU'
import * as networksHuHU from './sections/networks.hu-HU'
import * as storageHuHU from './sections/storage.hu-HU'
import * as hciHuHU from './sections/hci.hu-HU'
import * as vmsHuHU from './sections/vms.hu-HU'

import * as commonHrHR from './sections/common.hr-HR'
import * as authHrHR from './sections/auth.hr-HR'
import * as clusterHrHR from './sections/cluster.hr-HR'
import * as systemHrHR from './sections/system.hr-HR'
import * as tasksHrHR from './sections/tasks.hr-HR'
import * as appsHrHR from './sections/apps.hr-HR'
import * as backupsHrHR from './sections/backups.hr-HR'
import * as networksHrHR from './sections/networks.hr-HR'
import * as storageHrHR from './sections/storage.hr-HR'
import * as hciHrHR from './sections/hci.hr-HR'
import * as vmsHrHR from './sections/vms.hr-HR'

import * as commonSkSK from './sections/common.sk-SK'
import * as authSkSK from './sections/auth.sk-SK'
import * as clusterSkSK from './sections/cluster.sk-SK'
import * as systemSkSK from './sections/system.sk-SK'
import * as tasksSkSK from './sections/tasks.sk-SK'
import * as appsSkSK from './sections/apps.sk-SK'
import * as backupsSkSK from './sections/backups.sk-SK'
import * as networksSkSK from './sections/networks.sk-SK'
import * as storageSkSK from './sections/storage.sk-SK'
import * as hciSkSK from './sections/hci.sk-SK'
import * as vmsSkSK from './sections/vms.sk-SK'

import * as commonCsCZ from './sections/common.cs-CZ'
import * as authCsCZ from './sections/auth.cs-CZ'
import * as clusterCsCZ from './sections/cluster.cs-CZ'
import * as systemCsCZ from './sections/system.cs-CZ'
import * as tasksCsCZ from './sections/tasks.cs-CZ'
import * as appsCsCZ from './sections/apps.cs-CZ'
import * as backupsCsCZ from './sections/backups.cs-CZ'
import * as networksCsCZ from './sections/networks.cs-CZ'
import * as storageCsCZ from './sections/storage.cs-CZ'
import * as hciCsCZ from './sections/hci.cs-CZ'
import * as vmsCsCZ from './sections/vms.cs-CZ'

import * as commonRoRO from './sections/common.ro-RO'
import * as authRoRO from './sections/auth.ro-RO'
import * as clusterRoRO from './sections/cluster.ro-RO'
import * as systemRoRO from './sections/system.ro-RO'
import * as tasksRoRO from './sections/tasks.ro-RO'
import * as appsRoRO from './sections/apps.ro-RO'
import * as backupsRoRO from './sections/backups.ro-RO'
import * as networksRoRO from './sections/networks.ro-RO'
import * as storageRoRO from './sections/storage.ro-RO'
import * as hciRoRO from './sections/hci.ro-RO'
import * as vmsRoRO from './sections/vms.ro-RO'

import * as commonIsIS from './sections/common.is-IS'
import * as authIsIS from './sections/auth.is-IS'
import * as clusterIsIS from './sections/cluster.is-IS'
import * as systemIsIS from './sections/system.is-IS'
import * as tasksIsIS from './sections/tasks.is-IS'
import * as appsIsIS from './sections/apps.is-IS'
import * as backupsIsIS from './sections/backups.is-IS'
import * as networksIsIS from './sections/networks.is-IS'
import * as storageIsIS from './sections/storage.is-IS'
import * as hciIsIS from './sections/hci.is-IS'
import * as vmsIsIS from './sections/vms.is-IS'

import * as commonUkUA from './sections/common.uk-UA'
import * as authUkUA from './sections/auth.uk-UA'
import * as clusterUkUA from './sections/cluster.uk-UA'
import * as systemUkUA from './sections/system.uk-UA'
import * as tasksUkUA from './sections/tasks.uk-UA'
import * as appsUkUA from './sections/apps.uk-UA'
import * as backupsUkUA from './sections/backups.uk-UA'
import * as networksUkUA from './sections/networks.uk-UA'
import * as storageUkUA from './sections/storage.uk-UA'
import * as hciUkUA from './sections/hci.uk-UA'
import * as vmsUkUA from './sections/vms.uk-UA'

import * as commonRuRU from './sections/common.ru-RU'
import * as authRuRU from './sections/auth.ru-RU'
import * as clusterRuRU from './sections/cluster.ru-RU'
import * as systemRuRU from './sections/system.ru-RU'
import * as tasksRuRU from './sections/tasks.ru-RU'
import * as appsRuRU from './sections/apps.ru-RU'
import * as backupsRuRU from './sections/backups.ru-RU'
import * as networksRuRU from './sections/networks.ru-RU'
import * as storageRuRU from './sections/storage.ru-RU'
import * as hciRuRU from './sections/hci.ru-RU'
import * as vmsRuRU from './sections/vms.ru-RU'

import * as commonEnGB from './sections/common.en-GB'
import * as authEnGB from './sections/auth.en-GB'
import * as clusterEnGB from './sections/cluster.en-GB'
import * as systemEnGB from './sections/system.en-GB'
import * as tasksEnGB from './sections/tasks.en-GB'
import * as appsEnGB from './sections/apps.en-GB'
import * as backupsEnGB from './sections/backups.en-GB'
import * as networksEnGB from './sections/networks.en-GB'
import * as storageEnGB from './sections/storage.en-GB'
import * as hciEnGB from './sections/hci.en-GB'
import * as vmsEnGB from './sections/vms.en-GB'

import * as commonEsMX from './sections/common.es-MX'
import * as authEsMX from './sections/auth.es-MX'
import * as clusterEsMX from './sections/cluster.es-MX'
import * as systemEsMX from './sections/system.es-MX'
import * as tasksEsMX from './sections/tasks.es-MX'
import * as appsEsMX from './sections/apps.es-MX'
import * as backupsEsMX from './sections/backups.es-MX'
import * as networksEsMX from './sections/networks.es-MX'
import * as storageEsMX from './sections/storage.es-MX'
import * as hciEsMX from './sections/hci.es-MX'
import * as vmsEsMX from './sections/vms.es-MX'

import * as commonPtBR from './sections/common.pt-BR'
import * as authPtBR from './sections/auth.pt-BR'
import * as clusterPtBR from './sections/cluster.pt-BR'
import * as systemPtBR from './sections/system.pt-BR'
import * as tasksPtBR from './sections/tasks.pt-BR'
import * as appsPtBR from './sections/apps.pt-BR'
import * as backupsPtBR from './sections/backups.pt-BR'
import * as networksPtBR from './sections/networks.pt-BR'
import * as storagePtBR from './sections/storage.pt-BR'
import * as hciPtBR from './sections/hci.pt-BR'
import * as vmsPtBR from './sections/vms.pt-BR'

// Wave 1 (task #171): es, pt (pt-PT), fr, de join en/it. Wave 2 (nordics,
// onda 2): da, fi, no (bokmål), sv. Wave 3 (east, onda 3): nl, pl, lv, lt, et
// + uk, ru (Cyrillic — the loans kept by the Italian source are written IN
// CYRILLIC where the Cyrillic loan is the live one, otherwise the standard
// Cyrillic term wins). Icelandic (is-IS) joined by explicit ratification (Luca
// 2026-08-04) as the 28th language ON TOP of the 27-language plan. Wave 4
// (onda 4, appending as each language lands): ro-RO (covers Moldova too —
// backlog #171 point (a): mo = ro, a future ro-MD would be a regional delta),
// cs-CZ. Wave 5 appends here. 'sr-Cyrl-RS' (ratifica Luca 2026-08-07) è il
// serbo CIRILLICO, traslitterazione meccanica di 'sr-Latn-RS'
// (scripts/i18n-sr-cyrl.mjs): sta accanto alla latinica.
//
// L'IDENTIFICATORE DI LOCALE È IL TAG BCP 47 PIENO (ratifica Luca 2026-08-07:
// «internamente il codice delle lingue non dovrebbe essere breve, ma esteso»).
// Forma CANONICA: lingua minuscola, script Capitalizzato, regione MAIUSCOLA —
// 'en-US', 'pt-PT', 'sr-Latn-RS'. Il tag nomina TUTTO: la chiave di
// `dictionaries`, i file di sezione, i sidecar meta, il valore in localStorage
// e nel cookie. Non è cosmesi: due varianti della stessa lingua (en-US/en-GB,
// es-ES/es-MX, pt-PT/pt-BR) sono INDISTINGUIBILI da un codice nudo, quindi
// senza tag pieno le varianti regionali non esistono proprio.
//
// Corollario: NON esiste più una funzione codice→tag (il vecchio `bcp47()`).
// L'identificatore È il tag, quindi Intl.*, <html lang> e i sidecar ricevono
// `lang` così com'è; tenerla come identità sarebbe solo un invito a far
// divergere di nuovo le due cose, che è esattamente il debito che questo
// round chiude.
//
// ORDINE: la locale BASE di ogni lingua viene PRIMA delle sue varianti —
// il rilevamento dal browser (./index) ci conta per rispondere 'es-ES' a un
// 'es-AR' che non serviamo.
export const LOCALES = [
  'en-US', 'en-GB', 'it-IT', 'es-ES', 'es-MX', 'pt-PT', 'pt-BR', 'fr-FR', 'de-DE', 'da-DK',
  'fi-FI', 'no-NO', 'sv-SE', 'nl-NL', 'pl-PL', 'lv-LV', 'lt-LT', 'et-EE', 'uk-UA', 'ru-RU',
  'is-IS', 'ro-RO', 'cs-CZ', 'sk-SK', 'hr-HR', 'hu-HU', 'el-GR', 'tr-TR', 'bg-BG',
  'sr-Latn-RS', 'sr-Cyrl-RS', 'sq-AL', 'hy-AM'
] as const

export type Lang = (typeof LOCALES)[number]

// The source language of every string (see governance note above): parity and
// staleness are measured against THIS locale, not against English.
export const SOURCE_LANG: Lang = 'it-IT'

export const isLang = (value: unknown): value is Lang =>
  typeof value === 'string' && (LOCALES as readonly string[]).includes(value)

// Le VARIANTI REGIONALI e la loro base (modello delta, ./delta.ts): la variante
// dichiara solo le stringhe che scrive diversamente e il resto lo eredita.
// Ri-tipizzata QUI su `Lang` perché ./delta non importa niente (lo leggono
// anche gli script node): un tag non registrato in LOCALES non compila.
export const VARIANT_OF: Partial<Record<Lang, Lang>> = VARIANT_BASE

// Codici brevi già persistiti prima del passaggio ai tag pieni: chi aveva
// scelto 'it' non deve ritrovarsi la GUI in inglese al primo caricamento dopo
// l'aggiornamento. La mappa vive QUI e non nel provider perché è la tabella di
// conversione dell'identificatore, non un dettaglio di React; si legge in
// ./index alla lettura di localStorage/cookie, che vengono poi RISCRITTI col
// tag pieno (migrazione una tantum, non una traduzione a ogni avvio).
// Elencata per intero e non dedotta dal prefisso: 'srCyrl' non aveva prefisso
// deducibile, e una tabella esplicita non può sbagliare in silenzio.
const LEGACY_LANG_CODES: Record<string, Lang> = {
  en: 'en-US', it: 'it-IT', es: 'es-ES', pt: 'pt-PT', fr: 'fr-FR', de: 'de-DE',
  da: 'da-DK', fi: 'fi-FI', no: 'no-NO', sv: 'sv-SE', nl: 'nl-NL', pl: 'pl-PL',
  lv: 'lv-LV', lt: 'lt-LT', et: 'et-EE', uk: 'uk-UA', ru: 'ru-RU', is: 'is-IS',
  ro: 'ro-RO', cs: 'cs-CZ', sk: 'sk-SK', hr: 'hr-HR', hu: 'hu-HU', el: 'el-GR',
  tr: 'tr-TR', bg: 'bg-BG', sr: 'sr-Latn-RS', srCyrl: 'sr-Cyrl-RS', sq: 'sq-AL',
  hy: 'hy-AM'
}

// Un valore persistito → la locale che rappresenta oggi, o undefined se non
// significa niente (chiave manomessa, lingua ritirata): chi chiama decide il
// fallback. Restituisce ANCHE il tag pieno quando è già tale, così il chiamante
// distingue «da migrare» da «già a posto» confrontando col valore letto.
export const resolvePersistedLang = (value: unknown): Lang | undefined => {
  if (isLang(value)) {
    return value
  }

  if (typeof value === 'string' && value in LEGACY_LANG_CODES) {
    return LEGACY_LANG_CODES[value]
  }

  return undefined
}

// La locale servita per una lingua richiesta senza variante, o con una
// variante che non serviamo ('es-AR' → 'es-ES'): la PRIMA locale registrata
// con lo stesso sottotag primario, che per costruzione di LOCALES è la base.
export const defaultLocaleFor = (primary: string): Lang | undefined =>
  LOCALES.find(locale => locale.slice(0, locale.indexOf('-')).toLowerCase() === primary.toLowerCase())

// In ordine ALFABETICO di codice (Luca 2026-08-03): con diciassette lingue
// oggi e ventisette in roadmap (#171), una lista in ordine di aggiunta
// diventa una caccia al tesoro. L'ordine è sul CODICE, che è anche ciò che
// l'utente legge per primo nell'etichetta.
//
// `flag` è la bandiera twemoji del PAESE della variante servita; `name` è
// l'endonimo. Il tag NON è più un campo a sé (task #171, tag pieni): `code` È
// il tag, e il menu incolonna quello — un secondo campo identico sarebbe solo
// una copia da tenere allineata a mano.
// La variante è quella del paese servito: `(en-US) English (US)` con la
// bandiera statunitense perché quell'inglese è en-US, `(pt-PT) Português
// (Portugal)` col Portogallo — le varianti regionali hanno riga, bandiera e
// tag propri. Per le lingue con varianti si qualifica ANCHE la base (ratifica
// Luca 2026-08-09, F5): due righe «English» nude non si distinguono a colpo
// d'occhio. Le lingue senza varianti restano nude (Italiano, Deutsch…).
//
// Sottosezioni per CONTINENTE (ratifica Luca 2026-08-07): il selettore
// raggruppa le lingue per `region` — l'ordine di presentazione è QUESTO array,
// le sezioni vuote non si rendono. L'union è CHIUSA apposta: quando l'onda
// asiatica (o altra) aggiungerà un continente, si estende qui e il compilatore
// nomina ogni punto da toccare (dropdown, etichette i18n, icona di sezione).
// Americhe DIVISE in Nord e Sud (ratifica Luca 2026-08-07): «ci tornerà
// utile per es-MX e pt-BR» — il Messico è Nord America, il Brasile Sud.
export const LANG_REGIONS = ['europe', 'northAmerica', 'southAmerica', 'asia'] as const

export type LangRegion = (typeof LANG_REGIONS)[number]

// Le assegnazioni sono DECISE (Luca 2026-08-07): `en-US` sta in Nord America
// perché è la variante servita (bandiera e tag lo dicono già); `tr-TR` e
// `hy-AM` in Asia; tutte le altre in Europa.
export const LANGUAGES: { code: Lang; name: string; flag: string; region: LangRegion }[] = [
  { code: 'bg-BG', name: 'Български', flag: 'twemoji-flag-bulgaria', region: 'europe' },
  { code: 'cs-CZ', name: 'Čeština', flag: 'twemoji-flag-czechia', region: 'europe' },
  { code: 'da-DK', name: 'Dansk', flag: 'twemoji-flag-denmark', region: 'europe' },
  { code: 'de-DE', name: 'Deutsch', flag: 'twemoji-flag-germany', region: 'europe' },
  { code: 'el-GR', name: 'Ελληνικά', flag: 'twemoji-flag-greece', region: 'europe' },
  { code: 'en-GB', name: 'English (UK)', flag: 'twemoji-flag-united-kingdom', region: 'europe' },
  { code: 'en-US', name: 'English (US)', flag: 'twemoji-flag-united-states', region: 'northAmerica' },
  { code: 'es-ES', name: 'Español (España)', flag: 'twemoji-flag-spain', region: 'europe' },
  { code: 'es-MX', name: 'Español (México)', flag: 'twemoji-flag-mexico', region: 'northAmerica' },
  { code: 'et-EE', name: 'Eesti', flag: 'twemoji-flag-estonia', region: 'europe' },
  { code: 'fi-FI', name: 'Suomi', flag: 'twemoji-flag-finland', region: 'europe' },
  { code: 'fr-FR', name: 'Français', flag: 'twemoji-flag-france', region: 'europe' },
  { code: 'hr-HR', name: 'Hrvatski', flag: 'twemoji-flag-croatia', region: 'europe' },
  { code: 'hu-HU', name: 'Magyar', flag: 'twemoji-flag-hungary', region: 'europe' },
  { code: 'hy-AM', name: 'Հայերեն', flag: 'twemoji-flag-armenia', region: 'asia' },
  { code: 'is-IS', name: 'Íslenska', flag: 'twemoji-flag-iceland', region: 'europe' },
  { code: 'it-IT', name: 'Italiano', flag: 'twemoji-flag-italy', region: 'europe' },
  { code: 'lt-LT', name: 'Lietuvių', flag: 'twemoji-flag-lithuania', region: 'europe' },
  { code: 'lv-LV', name: 'Latviešu', flag: 'twemoji-flag-latvia', region: 'europe' },
  { code: 'nl-NL', name: 'Nederlands', flag: 'twemoji-flag-netherlands', region: 'europe' },
  { code: 'no-NO', name: 'Norsk', flag: 'twemoji-flag-norway', region: 'europe' },
  { code: 'pl-PL', name: 'Polski', flag: 'twemoji-flag-poland', region: 'europe' },
  { code: 'pt-BR', name: 'Português (Brasil)', flag: 'twemoji-flag-brazil', region: 'southAmerica' },
  { code: 'pt-PT', name: 'Português (Portugal)', flag: 'twemoji-flag-portugal', region: 'europe' },
  { code: 'ro-RO', name: 'Română', flag: 'twemoji-flag-romania', region: 'europe' },
  { code: 'ru-RU', name: 'Русский', flag: 'twemoji-flag-russia', region: 'europe' },
  { code: 'sk-SK', name: 'Slovenčina', flag: 'twemoji-flag-slovakia', region: 'europe' },
  { code: 'sq-AL', name: 'Shqip', flag: 'twemoji-flag-albania', region: 'europe' },

  // Il serbo esiste in ENTRAMBI gli alfabeti (ratifica Luca 2026-08-07): la
  // latinica domina nel digitale, la ćirilica è usata dalle pubbliche
  // amministrazioni, che sono target. 'sr-Cyrl-RS' è la traslitterazione
  // MECCANICA di 'sr-Latn-RS' (come previsto fin dalla nascita del serbo):
  // si rigenera con scripts/i18n-sr-cyrl.mjs, mai a mano. Il tag DICE lo
  // script perché in serbo lo script è informazione, non dettaglio; i name lo
  // ripetono nell'alfabeto rispettivo perché è ciò che l'utente cerca con gli
  // occhi. Stessa bandiera, stesso paese: le due righe stanno ADIACENTI.
  { code: 'sr-Latn-RS', name: 'Srpski (latinica)', flag: 'twemoji-flag-serbia', region: 'europe' },
  { code: 'sr-Cyrl-RS', name: 'Српски (ћирилица)', flag: 'twemoji-flag-serbia', region: 'europe' },
  { code: 'sv-SE', name: 'Svenska', flag: 'twemoji-flag-sweden', region: 'europe' },
  { code: 'tr-TR', name: 'Türkçe', flag: 'twemoji-flag-turkey', region: 'asia' },
  { code: 'uk-UA', name: 'Українська', flag: 'twemoji-flag-ukraine', region: 'europe' }
]

const enUS = {
  ...common.enUS,
  ...auth.enUS,
  ...cluster.enUS,
  ...system.enUS,
  ...tasks.enUS,
  ...apps.enUS,
  ...backups.enUS,
  ...networks.enUS,
  ...storage.enUS,
  ...hci.enUS,
  ...vms.enUS
}

const enGB: typeof enUS = mergeDelta(enUS, {
  ...commonEnGB.enGB,
  ...authEnGB.enGB,
  ...clusterEnGB.enGB,
  ...systemEnGB.enGB,
  ...tasksEnGB.enGB,
  ...appsEnGB.enGB,
  ...backupsEnGB.enGB,
  ...networksEnGB.enGB,
  ...storageEnGB.enGB,
  ...hciEnGB.enGB,
  ...vmsEnGB.enGB
})

const itIT: typeof enUS = {
  ...common.itIT,
  ...auth.itIT,
  ...cluster.itIT,
  ...system.itIT,
  ...tasks.itIT,
  ...apps.itIT,
  ...backups.itIT,
  ...networks.itIT,
  ...storage.itIT,
  ...hci.itIT,
  ...vms.itIT
}

const esES: typeof enUS = {
  ...commonEsES.esES,
  ...authEsES.esES,
  ...clusterEsES.esES,
  ...systemEsES.esES,
  ...tasksEsES.esES,
  ...appsEsES.esES,
  ...backupsEsES.esES,
  ...networksEsES.esES,
  ...storageEsES.esES,
  ...hciEsES.esES,
  ...vmsEsES.esES
}

const esMX: typeof enUS = mergeDelta(esES, {
  ...commonEsMX.esMX,
  ...authEsMX.esMX,
  ...clusterEsMX.esMX,
  ...systemEsMX.esMX,
  ...tasksEsMX.esMX,
  ...appsEsMX.esMX,
  ...backupsEsMX.esMX,
  ...networksEsMX.esMX,
  ...storageEsMX.esMX,
  ...hciEsMX.esMX,
  ...vmsEsMX.esMX
})

const ptPT: typeof enUS = {
  ...commonPtPT.ptPT,
  ...authPtPT.ptPT,
  ...clusterPtPT.ptPT,
  ...systemPtPT.ptPT,
  ...tasksPtPT.ptPT,
  ...appsPtPT.ptPT,
  ...backupsPtPT.ptPT,
  ...networksPtPT.ptPT,
  ...storagePtPT.ptPT,
  ...hciPtPT.ptPT,
  ...vmsPtPT.ptPT
}

const ptBR: typeof enUS = mergeDelta(ptPT, {
  ...commonPtBR.ptBR,
  ...authPtBR.ptBR,
  ...clusterPtBR.ptBR,
  ...systemPtBR.ptBR,
  ...tasksPtBR.ptBR,
  ...appsPtBR.ptBR,
  ...backupsPtBR.ptBR,
  ...networksPtBR.ptBR,
  ...storagePtBR.ptBR,
  ...hciPtBR.ptBR,
  ...vmsPtBR.ptBR
})

const frFR: typeof enUS = {
  ...commonFrFR.frFR,
  ...authFrFR.frFR,
  ...clusterFrFR.frFR,
  ...systemFrFR.frFR,
  ...tasksFrFR.frFR,
  ...appsFrFR.frFR,
  ...backupsFrFR.frFR,
  ...networksFrFR.frFR,
  ...storageFrFR.frFR,
  ...hciFrFR.frFR,
  ...vmsFrFR.frFR
}

const deDE: typeof enUS = {
  ...commonDeDE.deDE,
  ...authDeDE.deDE,
  ...clusterDeDE.deDE,
  ...systemDeDE.deDE,
  ...tasksDeDE.deDE,
  ...appsDeDE.deDE,
  ...backupsDeDE.deDE,
  ...networksDeDE.deDE,
  ...storageDeDE.deDE,
  ...hciDeDE.deDE,
  ...vmsDeDE.deDE
}

const daDK: typeof enUS = {
  ...commonDaDK.daDK,
  ...authDaDK.daDK,
  ...clusterDaDK.daDK,
  ...systemDaDK.daDK,
  ...tasksDaDK.daDK,
  ...appsDaDK.daDK,
  ...backupsDaDK.daDK,
  ...networksDaDK.daDK,
  ...storageDaDK.daDK,
  ...hciDaDK.daDK,
  ...vmsDaDK.daDK
}

const fiFI: typeof enUS = {
  ...commonFiFI.fiFI,
  ...authFiFI.fiFI,
  ...clusterFiFI.fiFI,
  ...systemFiFI.fiFI,
  ...tasksFiFI.fiFI,
  ...appsFiFI.fiFI,
  ...backupsFiFI.fiFI,
  ...networksFiFI.fiFI,
  ...storageFiFI.fiFI,
  ...hciFiFI.fiFI,
  ...vmsFiFI.fiFI
}

const noNO: typeof enUS = {
  ...commonNoNO.noNO,
  ...authNoNO.noNO,
  ...clusterNoNO.noNO,
  ...systemNoNO.noNO,
  ...tasksNoNO.noNO,
  ...appsNoNO.noNO,
  ...backupsNoNO.noNO,
  ...networksNoNO.noNO,
  ...storageNoNO.noNO,
  ...hciNoNO.noNO,
  ...vmsNoNO.noNO
}

const svSE: typeof enUS = {
  ...commonSvSE.svSE,
  ...authSvSE.svSE,
  ...clusterSvSE.svSE,
  ...systemSvSE.svSE,
  ...tasksSvSE.svSE,
  ...appsSvSE.svSE,
  ...backupsSvSE.svSE,
  ...networksSvSE.svSE,
  ...storageSvSE.svSE,
  ...hciSvSE.svSE,
  ...vmsSvSE.svSE
}

const nlNL: typeof enUS = {
  ...commonNlNL.nlNL,
  ...authNlNL.nlNL,
  ...clusterNlNL.nlNL,
  ...systemNlNL.nlNL,
  ...tasksNlNL.nlNL,
  ...appsNlNL.nlNL,
  ...backupsNlNL.nlNL,
  ...networksNlNL.nlNL,
  ...storageNlNL.nlNL,
  ...hciNlNL.nlNL,
  ...vmsNlNL.nlNL
}

const plPL: typeof enUS = {
  ...commonPlPL.plPL,
  ...authPlPL.plPL,
  ...clusterPlPL.plPL,
  ...systemPlPL.plPL,
  ...tasksPlPL.plPL,
  ...appsPlPL.plPL,
  ...backupsPlPL.plPL,
  ...networksPlPL.plPL,
  ...storagePlPL.plPL,
  ...hciPlPL.plPL,
  ...vmsPlPL.plPL
}

const lvLV: typeof enUS = {
  ...commonLvLV.lvLV,
  ...authLvLV.lvLV,
  ...clusterLvLV.lvLV,
  ...systemLvLV.lvLV,
  ...tasksLvLV.lvLV,
  ...appsLvLV.lvLV,
  ...backupsLvLV.lvLV,
  ...networksLvLV.lvLV,
  ...storageLvLV.lvLV,
  ...hciLvLV.lvLV,
  ...vmsLvLV.lvLV
}

const ltLT: typeof enUS = {
  ...commonLtLT.ltLT,
  ...authLtLT.ltLT,
  ...clusterLtLT.ltLT,
  ...systemLtLT.ltLT,
  ...tasksLtLT.ltLT,
  ...appsLtLT.ltLT,
  ...backupsLtLT.ltLT,
  ...networksLtLT.ltLT,
  ...storageLtLT.ltLT,
  ...hciLtLT.ltLT,
  ...vmsLtLT.ltLT
}

const etEE: typeof enUS = {
  ...commonEtEE.etEE,
  ...authEtEE.etEE,
  ...clusterEtEE.etEE,
  ...systemEtEE.etEE,
  ...tasksEtEE.etEE,
  ...appsEtEE.etEE,
  ...backupsEtEE.etEE,
  ...networksEtEE.etEE,
  ...storageEtEE.etEE,
  ...hciEtEE.etEE,
  ...vmsEtEE.etEE
}

const hyAM: typeof enUS = {
  ...commonHyAM.hyAM,
  ...authHyAM.hyAM,
  ...clusterHyAM.hyAM,
  ...systemHyAM.hyAM,
  ...tasksHyAM.hyAM,
  ...appsHyAM.hyAM,
  ...backupsHyAM.hyAM,
  ...networksHyAM.hyAM,
  ...storageHyAM.hyAM,
  ...hciHyAM.hyAM,
  ...vmsHyAM.hyAM
}

const sqAL: typeof enUS = {
  ...commonSqAL.sqAL,
  ...authSqAL.sqAL,
  ...clusterSqAL.sqAL,
  ...systemSqAL.sqAL,
  ...tasksSqAL.sqAL,
  ...appsSqAL.sqAL,
  ...backupsSqAL.sqAL,
  ...networksSqAL.sqAL,
  ...storageSqAL.sqAL,
  ...hciSqAL.sqAL,
  ...vmsSqAL.sqAL
}

const srLatnRS: typeof enUS = {
  ...commonSrLatnRS.srLatnRS,
  ...authSrLatnRS.srLatnRS,
  ...clusterSrLatnRS.srLatnRS,
  ...systemSrLatnRS.srLatnRS,
  ...tasksSrLatnRS.srLatnRS,
  ...appsSrLatnRS.srLatnRS,
  ...backupsSrLatnRS.srLatnRS,
  ...networksSrLatnRS.srLatnRS,
  ...storageSrLatnRS.srLatnRS,
  ...hciSrLatnRS.srLatnRS,
  ...vmsSrLatnRS.srLatnRS
}

const srCyrlRS: typeof enUS = {
  ...commonSrCyrlRS.srCyrlRS,
  ...authSrCyrlRS.srCyrlRS,
  ...clusterSrCyrlRS.srCyrlRS,
  ...systemSrCyrlRS.srCyrlRS,
  ...tasksSrCyrlRS.srCyrlRS,
  ...appsSrCyrlRS.srCyrlRS,
  ...backupsSrCyrlRS.srCyrlRS,
  ...networksSrCyrlRS.srCyrlRS,
  ...storageSrCyrlRS.srCyrlRS,
  ...hciSrCyrlRS.srCyrlRS,
  ...vmsSrCyrlRS.srCyrlRS
}

const bgBG: typeof enUS = {
  ...commonBgBG.bgBG,
  ...authBgBG.bgBG,
  ...clusterBgBG.bgBG,
  ...systemBgBG.bgBG,
  ...tasksBgBG.bgBG,
  ...appsBgBG.bgBG,
  ...backupsBgBG.bgBG,
  ...networksBgBG.bgBG,
  ...storageBgBG.bgBG,
  ...hciBgBG.bgBG,
  ...vmsBgBG.bgBG
}

const trTR: typeof enUS = {
  ...commonTrTR.trTR,
  ...authTrTR.trTR,
  ...clusterTrTR.trTR,
  ...systemTrTR.trTR,
  ...tasksTrTR.trTR,
  ...appsTrTR.trTR,
  ...backupsTrTR.trTR,
  ...networksTrTR.trTR,
  ...storageTrTR.trTR,
  ...hciTrTR.trTR,
  ...vmsTrTR.trTR
}

const elGR: typeof enUS = {
  ...commonElGR.elGR,
  ...authElGR.elGR,
  ...clusterElGR.elGR,
  ...systemElGR.elGR,
  ...tasksElGR.elGR,
  ...appsElGR.elGR,
  ...backupsElGR.elGR,
  ...networksElGR.elGR,
  ...storageElGR.elGR,
  ...hciElGR.elGR,
  ...vmsElGR.elGR
}

const huHU: typeof enUS = {
  ...commonHuHU.huHU,
  ...authHuHU.huHU,
  ...clusterHuHU.huHU,
  ...systemHuHU.huHU,
  ...tasksHuHU.huHU,
  ...appsHuHU.huHU,
  ...backupsHuHU.huHU,
  ...networksHuHU.huHU,
  ...storageHuHU.huHU,
  ...hciHuHU.huHU,
  ...vmsHuHU.huHU
}

const hrHR: typeof enUS = {
  ...commonHrHR.hrHR,
  ...authHrHR.hrHR,
  ...clusterHrHR.hrHR,
  ...systemHrHR.hrHR,
  ...tasksHrHR.hrHR,
  ...appsHrHR.hrHR,
  ...backupsHrHR.hrHR,
  ...networksHrHR.hrHR,
  ...storageHrHR.hrHR,
  ...hciHrHR.hrHR,
  ...vmsHrHR.hrHR
}

const skSK: typeof enUS = {
  ...commonSkSK.skSK,
  ...authSkSK.skSK,
  ...clusterSkSK.skSK,
  ...systemSkSK.skSK,
  ...tasksSkSK.skSK,
  ...appsSkSK.skSK,
  ...backupsSkSK.skSK,
  ...networksSkSK.skSK,
  ...storageSkSK.skSK,
  ...hciSkSK.skSK,
  ...vmsSkSK.skSK
}

const csCZ: typeof enUS = {
  ...commonCsCZ.csCZ,
  ...authCsCZ.csCZ,
  ...clusterCsCZ.csCZ,
  ...systemCsCZ.csCZ,
  ...tasksCsCZ.csCZ,
  ...appsCsCZ.csCZ,
  ...backupsCsCZ.csCZ,
  ...networksCsCZ.csCZ,
  ...storageCsCZ.csCZ,
  ...hciCsCZ.csCZ,
  ...vmsCsCZ.csCZ
}

const roRO: typeof enUS = {
  ...commonRoRO.roRO,
  ...authRoRO.roRO,
  ...clusterRoRO.roRO,
  ...systemRoRO.roRO,
  ...tasksRoRO.roRO,
  ...appsRoRO.roRO,
  ...backupsRoRO.roRO,
  ...networksRoRO.roRO,
  ...storageRoRO.roRO,
  ...hciRoRO.roRO,
  ...vmsRoRO.roRO
}

const isIS: typeof enUS = {
  ...commonIsIS.isIS,
  ...authIsIS.isIS,
  ...clusterIsIS.isIS,
  ...systemIsIS.isIS,
  ...tasksIsIS.isIS,
  ...appsIsIS.isIS,
  ...backupsIsIS.isIS,
  ...networksIsIS.isIS,
  ...storageIsIS.isIS,
  ...hciIsIS.isIS,
  ...vmsIsIS.isIS
}

const ukUA: typeof enUS = {
  ...commonUkUA.ukUA,
  ...authUkUA.ukUA,
  ...clusterUkUA.ukUA,
  ...systemUkUA.ukUA,
  ...tasksUkUA.ukUA,
  ...appsUkUA.ukUA,
  ...backupsUkUA.ukUA,
  ...networksUkUA.ukUA,
  ...storageUkUA.ukUA,
  ...hciUkUA.ukUA,
  ...vmsUkUA.ukUA
}

const ruRU: typeof enUS = {
  ...commonRuRU.ruRU,
  ...authRuRU.ruRU,
  ...clusterRuRU.ruRU,
  ...systemRuRU.ruRU,
  ...tasksRuRU.ruRU,
  ...appsRuRU.ruRU,
  ...backupsRuRU.ruRU,
  ...networksRuRU.ruRU,
  ...storageRuRU.ruRU,
  ...hciRuRU.ruRU,
  ...vmsRuRU.ruRU
}

export type Dictionary = typeof enUS

export const dictionaries: Record<Lang, Dictionary> = {
  'en-US': enUS,
  'en-GB': enGB,
  'it-IT': itIT,
  'es-ES': esES,
  'es-MX': esMX,
  'pt-PT': ptPT,
  'pt-BR': ptBR,
  'fr-FR': frFR,
  'de-DE': deDE,
  'da-DK': daDK,
  'fi-FI': fiFI,
  'no-NO': noNO,
  'sv-SE': svSE,
  'nl-NL': nlNL,
  'pl-PL': plPL,
  'lv-LV': lvLV,
  'lt-LT': ltLT,
  'et-EE': etEE,
  'uk-UA': ukUA,
  'ru-RU': ruRU,
  'is-IS': isIS,
  'ro-RO': roRO,
  'cs-CZ': csCZ,
  'sk-SK': skSK,
  'hr-HR': hrHR,
  'hu-HU': huHU,
  'el-GR': elGR,
  'tr-TR': trTR,
  'bg-BG': bgBG,
  'sr-Latn-RS': srLatnRS,
  'sr-Cyrl-RS': srCyrlRS,
  'sq-AL': sqAL,
  'hy-AM': hyAM
}
